import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { __rest } from '../../_virtual/_tslib.js';
import React from 'react';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp, fRef } from '../../utils/React.js';
import { ActionPresentation } from '../Action/ActionPresentation.js';
import { hostClass } from './NavigationItem.styles.js';

// Hack to get rid of forwardRefs
var Div = fRef(function (_a) {
  var ref = _a.ref,
    props = __rest(_a, ["ref"]);
  return /*#__PURE__*/React.createElement("div", Object.assign({}, props, {
    ref: ref
  }));
});
var NavigationItemPresentation = fComp(function (props) {
  var _cleanupClassObject, _cleanupClassObject2;
  var className = props.className,
    children = props.children,
    actionRef = props.actionRef,
    hasMouseHover = props.hasMouseHover,
    hasKeyboardFocus = props.hasKeyboardFocus,
    disabled = props.disabled,
    href = props.href,
    level = props.level,
    secondary = props.secondary,
    innerRef = props.innerRef,
    otherProps = __rest(props, ["className", "children", "actionRef", "hasMouseHover", "hasKeyboardFocus", "disabled", "href", "level", "secondary", "innerRef"]);
  var textColor = disabled && "disabled" || secondary && "secondary" || "primary";
  return /*#__PURE__*/React.createElement(Host, {
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, className, !!className), _cleanupClassObject))
  }, /*#__PURE__*/React.createElement(ActionPresentation, Object.assign({
    ref: actionRef,
    disabled: disabled,
    href: disabled ? undefined : href
  }, otherProps), /*#__PURE__*/React.createElement(Div, {
    className: cleanupClassObject((_cleanupClassObject2 = {}, _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-inner"), true), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__hover"), !disabled && (hasMouseHover || hasKeyboardFocus)), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__focus"), !disabled && hasKeyboardFocus), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__").concat(textColor), true), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "__").concat(level), level), _cleanupClassObject2)),
    ref: innerRef
  }, children)));
});
NavigationItemPresentation.displayName = "NavigationItemPresentation";

export { NavigationItemPresentation };
